import type { ReactNode } from 'react';

import styles from './StatCard.module.scss';

type StatCardProps = {
  readonly label: string;
  readonly value: number | string;
  readonly icon?: ReactNode;
};

export function StatCard({ label, value, icon }: StatCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.stack}>
        {icon && <div className={styles.iconBox}>{icon}</div>}
        <span className={styles.label}>{label}</span>
        <span className={styles.value}>{value}</span>
      </div>
    </div>
  );
}
